import Vue from "vue";
import utils from "@/utils.js";

export default {
    methods: {
        catalogentry_price(entry, recurring, include_vat_type) {
            var price = "";
            let vat_type = "";
            if (include_vat_type) {
                if (entry.unit_amount_includes_vat) {
                    vat_type = Vue.prototype.$translate("catalogentry.labels.inclVat");
                } else {
                    vat_type = Vue.prototype.$translate("catalogentry.labels.exclVat");
                }
            }
            if (entry.recurring || recurring) {
                if (entry.saf) {
                    price = utils.price(entry.saf);
                }
                if (entry.unit_amount_includes_vat) {
                    return `${utils.price(
                        entry.unit_amount
                    )} ${vat_type}   / ${Vue.prototype.$translate(
                        "catalogentry.labels.month"
                    )}`;
                }
                return `${utils.price(
                    entry.unit_amount
                )} ${vat_type} / ${Vue.prototype.$translate(
                    "catalogentry.labels.month"
                )}`;
            }
            if (entry.algorythm == "custom") {
                price = Vue.prototype.$translate("catalogentry.labels.customAlgorithm");
            } else {
                if (entry.unit_amount_includes_vat) {
                    return `${utils.price(entry.unit_amount)}${vat_type}`;
                }
                return `${utils.price(entry.unit_amount)}${vat_type}`;
            }
            return price;
        },
    },
};
